module.exports = __webpack_public_path__ + "static/heirship-8f07d366e8d1338214a750846b24c3ec.png";